import { useQuery } from '@tanstack/react-query';
import apiClient from './axios';

export const PAYMENTS_TESTING_FEATURE_FLAG = 'paymentsTesting';

export interface RuntimeFeatureFlagsResponse {
  flags: Record<string, boolean>;
  metadata: {
    configured: boolean;
    source: 'appconfig' | 'default';
    stale: boolean;
    lastFetchedAt: string | null;
  };
}

export const runtimeFeatureFlagsQueryKey = ['runtime-feature-flags'] as const;

export const getRuntimeFeatureFlags = async (): Promise<RuntimeFeatureFlagsResponse> => {
  const response = await apiClient.get<RuntimeFeatureFlagsResponse>(
    '/feature-flags/runtime-config'
  );
  return response.data;
};

export const useRuntimeFeatureFlags = () =>
  useQuery({
    queryKey: runtimeFeatureFlagsQueryKey,
    queryFn: getRuntimeFeatureFlags,
    retry: false,
    staleTime: 45_000,
    refetchInterval: 60_000,
  });

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const isPaymentsTestingEnabled = (response: unknown): boolean => {
  if (!isRecord(response) || !isRecord(response.metadata) || !isRecord(response.flags)) {
    return false;
  }

  return (
    response.metadata.configured === true &&
    response.metadata.stale === false &&
    response.flags[PAYMENTS_TESTING_FEATURE_FLAG] === true
  );
};
